import React, { Component } from 'react'

export default class OneOnOneRow extends Component {
  constructor(props) {
    super(props)
  }

  getLocation() {
    if (this.props.p2p.meeting_location == undefined) {
      return ''
    } else {
      return 'Table ' + this.props.p2p.meeting_location
    }
  }

  participantOrOptOut() {
    const p2p = this.props.p2p
    const users = JSON.parse(localStorage.getItem('users')).event_users
    var otherUser = users?.find((user) => {
      return user?.user_id === p2p?.participant_user?.id
    })
    if (p2p.opted_out) {
      return ' - This time slot has been blocked.'
    } else {
      if (p2p.participant_user) {
        return otherUser ? ` - ${otherUser.first_name} ${otherUser.last_name}, ${otherUser.organization_name}` : ' - Please see staff member'
      } else {
        return ' - TBD'
      }
    }
  }

  getSessionInfo() {
    const p2p = this.props.p2p
    return (
      <a className="session-link"  key={p2p.id}>
        <p className='session-name'>
          {p2p.time_block_formatted_start_time == undefined ? 'TBD' : p2p.time_block_formatted_start_time}
          {this.participantOrOptOut()}
        </p>
        {/* <p className='session-room'>{this.getLocation()}</p> */}
      </a>
    )
  }


  render() {
    const session = this.props.session
    const trackColor = session.track_color ? session.track_color : '#f2f2f2'

    return (
      <div key={session.id} >
        <div className='container'>
          <div className='row session no-hover'>
            <button className='p2p-reg'>
              <p>Peer-to-Peer Meeting</p>
            </button>
            <div className='track-color' style={{ backgroundColor: trackColor }}></div>
            {this.getSessionInfo()}
          </div>
        </div>

      </div>
    )
  }
}
